var map = {
	"./en-001": [
		2014,
		0
	],
	"./en-001.json": [
		2014,
		0
	],
	"./en_CA": [
		2015,
		1
	],
	"./en_CA.json": [
		2015,
		1
	],
	"./en_US": [
		2016,
		2
	],
	"./en_US.json": [
		2016,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1518;
module.exports = webpackAsyncContext;